/**
 * 최근 본 현장 관리 Composable
 * - localStorage를 사용하여 최근 본 현장 ID 저장
 * - 최대 20개까지 저장
 */

const STORAGE_KEY = 'mulgae_recent_properties'
const MAX_ITEMS = 20

export function useRecent() {
  /**
   * 최근 본 현장 ID 목록 가져오기
   * @returns {string[]} 현장 ID 배열
   */
  const getRecentIds = () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (!stored) return []

      const parsed = JSON.parse(stored)

      // 배열이 아니면 빈 배열 반환
      if (!Array.isArray(parsed)) {
        localStorage.removeItem(STORAGE_KEY)
        return []
      }

      // 문자열 ID만 필터링 (잘못된 데이터 방어)
      const validIds = parsed.filter((item) => typeof item === 'string' && item.length > 0)

      // 잘못된 데이터가 있었으면 정리
      if (validIds.length !== parsed.length) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(validIds))
      }

      return validIds
    } catch {
      localStorage.removeItem(STORAGE_KEY)
      return []
    }
  }

  /**
   * 현장을 최근 본 목록에 추가
   * - 이미 있으면 맨 앞으로 이동
   * - 최대 개수 초과 시 오래된 것 삭제
   * @param {string} propertyId 현장 ID
   */
  const addRecent = (propertyId) => {
    if (!propertyId) return

    try {
      let recentIds = getRecentIds()

      // 이미 있으면 제거 (맨 앞으로 이동시키기 위해)
      recentIds = recentIds.filter((id) => id !== propertyId)

      // 맨 앞에 추가
      recentIds.unshift(propertyId)

      // 최대 개수 제한
      if (recentIds.length > MAX_ITEMS) {
        recentIds = recentIds.slice(0, MAX_ITEMS)
      }

      localStorage.setItem(STORAGE_KEY, JSON.stringify(recentIds))
    } catch (e) {
      console.error('최근 본 현장 저장 실패:', e)
    }
  }

  /**
   * 최근 본 현장 개수 가져오기
   * @returns {number}
   */
  const getRecentCount = () => {
    return getRecentIds().length
  }

  /**
   * 최근 본 현장 목록 초기화
   */
  const clearRecent = () => {
    try {
      localStorage.removeItem(STORAGE_KEY)
    } catch (e) {
      console.error('최근 본 현장 초기화 실패:', e)
    }
  }

  /**
   * 특정 현장 제거
   * @param {string} propertyId 현장 ID
   */
  const removeRecent = (propertyId) => {
    try {
      let recentIds = getRecentIds()
      recentIds = recentIds.filter((id) => id !== propertyId)
      localStorage.setItem(STORAGE_KEY, JSON.stringify(recentIds))
    } catch (e) {
      console.error('최근 본 현장 제거 실패:', e)
    }
  }

  return {
    getRecentIds,
    addRecent,
    getRecentCount,
    clearRecent,
    removeRecent
  }
}
